export default [
  {
    id: 'abc123',
    requestId: '123234',
    leaseId: '559394',
    fuelCardNumber: '123123',
    driver: 'Brad Trent',
    provider: 'Caltex',
    registration: 'ABC123',
    status: 'Active',
    issuedDate: '19 March 2020',
    address: {
      streetNumber: 38,
      address: 'Albert St',
      address2: undefined,
      suburb: 'Newtown',
      postCode: 2039,
      state: 'NSW',
      addressCountry: 'Australia'
    }
  },
  {
    id: 'abc124',
    requestId: '352234',
    leaseId: '23499304',
    fuelCardNumber: '2342351',
    driver: 'Emily Francois',
    provider: 'Caltex',
    registration: 'MCF233',
    status: 'Active',
    issuedDate: '4 April 2020',
    address: {
      streetNumber: 201,
      address: 'Loft Cres',
      address2: 'Unit 200',
      suburb: 'Meadowbank',
      postCode: 2588,
      state: 'NSW',
      addressCountry: 'Australia'
    }
  },
  {
    id: 'abc125',
    requestId: '098234',
    leaseId: '0345933',
    fuelCardNumber: '114249',
    driver: 'Chad Wilkinson',
    provider: 'Caltex',
    registration: 'MCF233',
    status: 'Active',
    issuedDate: '4 April 2020',
    address: {
      streetNumber: 2,
      address: 'Johnston St',
      address2: undefined,
      suburb: 'Annandale',
      postCode: 2038,
      state: 'NSW',
      addressCountry: 'Australia'
    }
  }
];



// WEBPACK FOOTER //
// ./src/features/fuel-cards/mockRows.js